module.exports = __webpack_public_path__ + "static/media/logo.bb77ee4c.svg";